module.exports = __webpack_public_path__ + "assets/arrow_bottom.a682e306.svg";